import { useRouter } from 'next/router';
import DropDown, { DropDownOption } from 'components/common/DropDown';
import { formatDate } from 'lib/dateUtils';
import { ShotRevision } from 'types/community';
import styles from './RevisionSelect.module.css';
import { getCommunityPath } from 'lib/community';

type Props = {
  revisions: ShotRevision[];
  lastUpdated: string;
  currentRevisionId: number;
};

export default function RevisionSelect({
  revisions,
  lastUpdated,
  currentRevisionId,
}: Props) {
  const router = useRouter();

  function onSelect(revisionId: string) {
    const revision = revisions.find(
      (r) => r.communityRevisionId === parseInt(revisionId, 10)
    );
    const { slug } = revision!;
    const url = getCommunityPath(slug);
    router.push(url, undefined, { shallow: false });
  }

  const options = revisions.map((revision, i) => {
    const n = revisions.length - i;
    const updated = new Date(revision.lastUpdated);
    const revisionId = revision.communityRevisionId.toString();

    return (
      <DropDownOption
        value={revisionId}
        key={revisionId}
        selected={revisionId === currentRevisionId.toString()}
      >
        <div className={styles.Option}>
          <div className={styles.Date}>{formatDate(updated)}</div>
          <div className={styles.Version}>{`v${n}`}</div>
        </div>
      </DropDownOption>
    );
  });

  return (
    <DropDown
      displayValue={formatDate(new Date(lastUpdated))}
      displayValueStyle={{ color: '#f1f1f1' }}
      onSelect={(revision) => onSelect(revision as string)}
    >
      {options}
    </DropDown>
  );
}
